<template>
  <div id="create-bloques-page">
    <vx-card>
      <!-- Conjunto Data -->
      <div class="vx-row leading-loose mt-3">
        <div class="vx-col w-full md:w-1/2">
          <h4>Información General</h4>
        </div>
      </div>
      <!-- Row -->
      <div class="vx-row leading-loose mt-3">
        <div class="vx-col w-full md:w-1/2">
          <vs-select
            v-model="bloqueData.conjunto"
            class="w-full select-large"
            label="Conjunto al que Pertenece"
          >
            <vs-select-item
              v-for="(item, index) in conjuntos"
              :key="index"
              :value="item.id"
              :text="item.nombre"
              class="w-full"
            />
          </vs-select>
        </div>
        <div class="vx-col w-full md:w-1/2">
          <vs-input
            v-model="bloqueData.name"
            name="nombre"
            label="Nombre del Bloque"
            class="w-full no-icon-border"
          />
        </div>
      </div>
      <!-- end row -->
      <!-- Unidades Table -->
      <div class="vx-row leading-loose mt-8">
        <div class="vx-col w-full md:w-1/2">
          <h4>Unidades del Bloque</h4>
        </div>
      </div>

      <div class="vx-row leading-loose mt-3">
        <div class="vx-col w-full">
          <vs-table
            :data="bloqueData.unidades"
            hover-flat
            no-data-text="No hay datos disponibles"
          >
            <!-- HEADER -->
            <template slot="thead">
              <vs-th class="w-full">Nombre de la Unidad</vs-th>
              <vs-th></vs-th>
            </template>

            <!-- DATA -->
            <template slot-scope="{ data }">
              <vs-tr v-for="(tr, index) in data" :key="index">
                <vs-td class="w-full">
                  <vs-input v-model="data[index].text" class="w-full" />
                </vs-td>
                <vs-td class="w-1/6">
                  <vs-button
                    color="danger"
                    type="flat"
                    @click="deleteRow(index)"
                    >Eliminar</vs-button
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <vs-button
        color="primary"
        icon="icon-plus"
        icon-before
        icon-pack="feather"
        type="flat"
        @click="addRow()"
        >Agregar Fila</vs-button
      >
      <!-- end Unidades Table -->

      <vs-row vs-type="flex" vs-justify="flex-end">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2">
          <vs-button
            type="filled"
            icon-pack="FA5"
            icon="far fa-save"
            @click="createBloque()"
            >Guardar</vs-button
          >
        </vs-col>
      </vs-row>

      <!-- end Conjunto Data -->
    </vx-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      colorAlert: "danger",
      bloqueData: {
        name: "",
        conjunto: "",
        unidades: [{ text: "" }]
      }
    };
  },
  computed: {
    ...mapState(["conjuntos"])
  },
  methods: {
    addRow() {
      this.bloqueData.unidades.push({
        text: ""
      });
    },
    deleteRow(producto) {
      this.bloqueData.unidades.splice(producto, 1);
    },
    createBloque() {
      this.$store
        .dispatch("createBloque", this.bloqueData)
        .then(result => {
          this.openAlert("success", result.message);
          this.$router.push({ name: "listBloques" });
        })
        .catch(err => {
          console.log(err.message);
        });
    },
    openAlert(color, message) {
      this.colorAlert = color || this.getColorRandom();
      this.$vs.dialog({
        color: this.colorAlert,
        title: "Aviso",
        text:
          this.colorAlert === "danger"
            ? " Ocurrio un error, por favor contacta al administrador"
            : message,
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.$vs.notify({
        color: this.colorAlert,
        title: "Aviso",
        text:
          this.colorAlert === "danger"
            ? " Por favor revisa todos los campos"
            : "Continuemos"
      });
    }
  },
  components: {}
};
</script>
